// eslint-disable-next-line no-shadow
enum FractionalDeadline {
  MINUTE,
  HOUR,
  DAY,
}
export default FractionalDeadline;
